import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreItemsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -4,
			y: -4,
			width: 40,
			height: 40,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					clipPath: "url(#bgblur_0_14969_163442_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			"data-figma-bg-blur-radius": 4,
			width: 32,
			height: 32,
			rx: 10,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 14C7.9 14 7 14.9 7 16C7 17.1 7.9 18 9 18C10.1 18 11 17.1 11 16C11 14.9 10.1 14 9 14Z",
			fill: "#6A4BC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 14C21.9 14 21 14.9 21 16C21 17.1 21.9 18 23 18C24.1 18 25 17.1 25 16C25 14.9 24.1 14 23 14Z",
			fill: "#6A4BC0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 14C14.9 14 14 14.9 14 16C14 17.1 14.9 18 16 18C17.1 18 18 17.1 18 16C18 14.9 17.1 14 16 14Z",
			fill: "#6A4BC0"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "bgblur_0_14969_163442_clip_path",
			transform: "translate(4 4)",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				rx: 10
			})
		}) })
	]
});
export default SvgMoreItemsIcon;
